import authRules from '../authRules.js';

const changeDayType = (user) => {
  const { changeDayType } = user.securityLevels;
  if (changeDayType >= authRules.changeDayType.changeDayType) {
      return true;
  } else {
      return false;
    }
  }


export default changeDayType;
